import type { ChatCardProps } from "../../types/ChatCard";
import { ConfirmationCard } from "./copilot/ConfirmationCard";
import { InvitationCard } from "./copilot/InvitationCard";
import { LinkCard } from "./copilot/LinkCard";
import { MemberListingCard } from "./copilot/MemberListingCard";

export const ChatCard = ({ type, content }: ChatCardProps) => {
  if (type === "invitation_link_card") {
    return <InvitationCard {...content} />;
  }

  if (type === "member_listing_card") {
    return <MemberListingCard {...content} />;
  }

  if (type === "confirmation_card") {
    return <ConfirmationCard {...content} />;
  }

  if (type === "link_card") {
    return <LinkCard {...content} />;
  }

  return null;
};
